import { propertyMeta, typeMeta, MetaTypesBase } from "@/autogen/common";
import { CountryCodeMeta } from "./CountryCodeMeta";
import { USStateCodeMeta } from "./USStateCodeMeta";

export const CreateAddressMetaFields = {
  line1: propertyMeta("line1", false, true, false, MetaTypesBase.string),
  line2: propertyMeta("line2", false, false, false, MetaTypesBase.string),
  line3: propertyMeta("line3", false, false, false, MetaTypesBase.string),
  city: propertyMeta("city", false, false, false, MetaTypesBase.string),
  state: propertyMeta("state", false, false, false, USStateCodeMeta),
  country: propertyMeta("country", false, true, false, CountryCodeMeta),
  zip: propertyMeta("zip", false, false, false, MetaTypesBase.string),
};

export const CreateAddressMeta = typeMeta("CreateAddress", CreateAddressMetaFields);
